import { Dropdown } from "@fluentui/react";
import React, { useContext,useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { BORDER } from "../../../../constants/Constants";
import themeContext from "../../../../context/theme/ThemeContext";

const dropDownStyles = {
  dropdown: {
    width: "200px",
  },
  dropdownItemsWrapper: {
    height: "300px",
  },
};

const QCFailReasons = ({ setQcReason, qcReason }) => {
  const { t } = useTranslation();
  const { getThemeColor } = useContext(themeContext);
  const reasons = [
    { value: "Add Contrast", label: "Add Contrast" },
    { value: "Add additional report", label: "Add additional report" },
    { value: "Incorrect side mentioned", label: "Incorrect side mentioned" },
    {
      value: "Spelling error/Typing error",
      label: "Spelling error/Typing error",
    },
    { value: "Template issue", label: "Template issue" },
    { value: "Fistula diagram Missed", label: "Fistula diagram Missed" },
    { value: "Canal Diameter Missed", label: "Canal Diameter Missed" },
    { value: "Projection missed", label: "Projection missed" },
    { value: "HU value missed", label: "HU value missed" },
    { value: "Kidney dimension", label: "Kidney dimension" },
    { value: "Cardimegaly", label: "Cardimegaly" },
    { value: "Comparative Report missed", label: "Comparative Report missed" },
    {
      value: "Pericardial effusion missed",
      label: "Pericardial effusion missed",
    },
    { value: "Effusion missed", label: "Effusion missed" },
    { value: "Fracture missed", label: "Fracture missed" },
    { value: "Midline shift", label: "Midline shift" },
    { value: "Hematoma size missed", label: "Hematoma size missed" },
    { value: "Screening report missed", label: "Screening report missed" },
    { value: "Sinusitis", label: "Sinusitis" },
    { value: "Soft tissue swelling ", label: "Soft tissue swelling " },
    { value: "Scoliosis", label: "Scoliosis" },
    { value: "Delete Blank Template", label: "Delete Blank Template" },
    { value: "Foley’s bulb missed", label: "Foley’s bulb missed" },
    { value: "Granuloma missed", label: "Granuloma missed" },
    { value: "Phleboliths missed", label: "Phleboliths missed" },
    { value: "GB calculi missed", label: "GB calculi missed" },
    { value: "Appendicitis missed", label: "Appendicitis missed" },
    { value: "Pancreatitis missed", label: "Pancreatitis missed" },
    { value: "Hemangioma missed", label: "Hemangioma missed" },
    { value: "Renal calculi missed", label: "Renal calculi missed" },
    { value: "Sacralization", label: "Sacralization" },
    { value: "Lumbarization", label: "Lumbarization" },
    { value: "Chest AP mention in title", label: "Chest AP mention in title" },
    { value: "Chest PA mention in title", label: "Chest PA mention in title" },
    { value: "Multiple ribs fracture", label: "Multiple ribs fracture" },
    { value: "Short reporting", label: "Short reporting" },
    { value: "Dislocation ", label: "Dislocation " },
    { value: "Hepatomegaly", label: "Hepatomegaly" },
    { value: "Spenomegaly", label: "Spenomegaly" },
    { value: "Liver lesion", label: "Liver lesion" },
    { value: "Corticle cyst", label: "Corticle cyst" },
    { value: "SDH missed", label: "SDH missed" },
    { value: "EDH missed", label: "EDH missed" },
    { value: "SAH missed", label: "SAH missed" },
    { value: "Cerebral atrophytrophy ", label: "Cerebral atrophytrophy " },
    { value: "Hemorrhagic Contusion", label: "Hemorrhagic Contusion" },
    { value: "Impression missed", label: "Impression missed" },
    { value: "Cystitis", label: "Cystitis" },
    { value: "Mastoiditis", label: "Mastoiditis" },
    { value: "Ichemic changes", label: "Ichemic changes" },
    { value: "Hydrocephalus", label: "Hydrocephalus" },
    { value: "Pnemocephalus", label: "Pnemocephalus" },
    { value: "Pneumothorax ", label: "Pneumothorax " },
    { value: "Ground glass opacity", label: "Ground glass opacity" },
    { value: "Dialated bowel loops", label: "Dialated bowel loops" },
    { value: "Bowel Obstruction", label: "Bowel Obstruction" },
    { value: "Radio-opaque density seen", label: "Radio-opaque density seen" },
    { value: "prostatomegaly", label: "prostatomegaly" },
    { value: "Uterus mentioned", label: "Uterus mentioned" },
    { value: "Prostate mentioned", label: "Prostate mentioned" },
    { value: "Abscess", label: "Abscess" },
    { value: "Sever marrow edema", label: "Sever marrow edema" },
    { value: "Potts spine", label: "Potts spine" },
    { value: "venous sinus thrombosis", label: "venous sinus thrombosis" },
    { value: "syrinx", label: "syrinx" },
    { value: "Dgenerative changes", label: "Dgenerative changes" },
    { value: "sacroiliitis", label: "sacroiliitis" },
    { value: "Asymmetric ventricle", label: "Asymmetric ventricle" },
    { value: "Infract missed", label: "Infract missed" },
    { value: "Bleed missed", label: "Bleed missed" },
    { value: "Post oprative status ", label: "Post oprative status " },
    { value: "Uterine Fibroid", label: "Uterine Fibroid" },
    { value: "Hydrocele", label: "Hydrocele" },
    { value: "Ovarian cyst", label: "Ovarian cyst" },
    { value: "Other", label: "Other" },
  ];
  // const handleDropDownClick = (e, item) => {
  const handleDropDownClick = (item) => {
    setQcReason(item.value);
  };

  useEffect(() => {
    const elements = document.querySelectorAll('.react-select-modal__single-value');
    //console.log("--- Elements ----",elements)
    if (elements.length > 0) {
      elements.forEach(element => {
        element.style.color = getThemeColor("primary-color");
      });
    }
  }, [document.querySelectorAll('.react-select-modal__single-value')]);

  return (
    <>
      {/* <Dropdown
        placeholder={t("QC.select-reason")}
        options={reasons}
        styles={dropDownStyles}
        onChange={handleDropDownClick}
      /> */}
      <Select
        classNamePrefix="react-select-modal"
        options={reasons}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            color: getThemeColor("primary-color"),
            backgroundColor: getThemeColor("action-details-background"),
            border: BORDER.TAB,
          }),
          menu: (baseStyles,state) => ({
            ...baseStyles,
            width: "100% !important",
            backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
            '&:hover': {
              backgroundColor: `${getThemeColor("popup-hover")} !important`,
            },
          }),
          menuList: (baseStyles, state) => ({
            ...baseStyles,
            backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
            '&:hover': {
              backgroundColor: `${getThemeColor("popup-hover")} !important`,
            },
          }),
          option: (provided, state) => ({
            ...provided,
            color: getThemeColor("primary-color"),
            backgroundColor: state.isFocused ? getThemeColor("popup-hover") : getThemeColor("action-details-background"),
            '&:hover': {
              backgroundColor: `${getThemeColor("popup-hover")} !important`,
            },
          }),
        }}
        placeholder={t("QC.select-reason")}
        onChange={(item) => {
          handleDropDownClick(item);
        }}
      />
    </>
  );
};

export default QCFailReasons;
